export const MenuListArray2 = [
    {
        title: 'Home',
        classChange: '',
        to: '/',
    },
    {
        title: 'Packages',
        classChange: '',
        to: '/#packages',
    },
    {
        title: 'Libraries',
        classChange: '',
        to: '/libraries',
    },
    {
        title: 'BMI Calculator',
        classChange: '',
        to: '/bmi-calculator',
    },
    {
        title: 'Nutrition Guide',
        classChange: '',
        to: '/nutrition-guide',
        feature: 'nutrition_guide',
    },
    {
        title: 'Contact Us',
        classChange: '',
        to: '/#contact',
    },
    {
        // One Program entry for both ends of the journey: the label reads
        // "Request a Program" until access is granted, then "My Program".
        title: 'My Program',
        requestTitle: 'Request a Program',
        classChange: '',
        to: '/my-program',
        programAware: true,
    },
];
